@if (grundstuecke) {
  <div>
    @for (g of grundstuecke; track g; let i = $index) {
      <span>
        @if (i < maxGrundstueckeProGebaeude) {
          <cap-link
            [queryParams]="{ id: g.id.id }"
            [target]="navTargets.NAV_GRUNDSTUECK"
            [tooltipParams]="{ nummer: g.grundstueckNummer | grundstuecknummerExtended }">
            {{ g | kompaktGrundstueck }}<br />
          </cap-link>
        }
        @if (i == maxGrundstueckeProGebaeude) {
          ... <br />
        }
      </span>
    }
  </div>
} @else {
  <span>
    <i class="fas fa-spinner fa-lg fa-fw fa-spin spinner" id="grundstueckSpinnerIcon"></i>
    <span class="sr-only">Loading...</span>
  </span>
}
